import { Column, Row } from 'app/design/primitives/box';
import { Modal } from 'app/design/primitives/modal';
import { Text } from 'app/design/primitives/text';
import { View } from 'react-native';
import { Button } from 'app/shopify';
import type { AlertPolyfill } from './shared';

export function ListingAlertModal({ alert, hideAlert }: { alert?: AlertPolyfill; hideAlert: () => void }) {
  return (
    <Modal onClose={hideAlert} open={Boolean(alert?.visible)} transparent>
      <Modal.Card>
        <Modal.Title>{alert?.title}</Modal.Title>
        <Column paddingHorizontal="spacing.general.x6">
          <Text variant="bodyBase">{alert?.message}</Text>
        </Column>
        <Row gap="spacing.general.x4" width="100%">
          {alert?.buttons?.map((button) => (
            <View key={JSON.stringify(button)} style={{ flex: 1 }}>
              <Button
                label={button.text}
                onPress={() => {
                  hideAlert();
                  button.onPress?.();
                }}
                variant={
                  button.style === 'destructive' ? 'destructive' : button.isPreferred ? 'primary' : 'secondaryNeutral'
                }
              />
            </View>
          ))}
        </Row>
      </Modal.Card>
    </Modal>
  );
}
